"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimTokenHelperStorageV2Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "defaultDepositPercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultVaultPoolId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingPoolAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tectonicSocketAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "xTonic",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610133806100206000396000f3fe6080604052348015600f57600080fd5b506004361060645760003560e01c80630e427a0e14606957806325b15a0c146098578063430bf08a1460aa578063546b0f231460bc578063620a98711460ce57806384d178321460e3578063edca5b681460eb575b600080fd5b600654607b906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b600454607b906001600160a01b031681565b600554607b906001600160a01b031681565b600254607b906001600160a01b031681565b60d660015481565b604051908152602001608f565b60d660005481565b600354607b906001600160a01b03168156fea2646970667358221220792f0cfa4c9498f24d1ac823347be64e69c94e9c933fc5d8ee179d4dd506238b64736f6c63430008030033";
class ClaimTokenHelperStorageV2Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ClaimTokenHelperStorageV2Factory = ClaimTokenHelperStorageV2Factory;
ClaimTokenHelperStorageV2Factory.bytecode = _bytecode;
ClaimTokenHelperStorageV2Factory.abi = _abi;
//# sourceMappingURL=ClaimTokenHelperStorageV2Factory.js.map